import { Component, DestroyRef, effect, inject, input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';
import { HlmFieldImports } from '@spartan-ng/helm/field';
import { HlmInputImports } from '@spartan-ng/helm/input';
import { debounceTime, distinctUntilChanged } from 'rxjs';

import { GroupeEtapesDetailContenuService } from './groupe-etapes-detail-contenu.service';

@Component({
  selector: 'app-groupe-etapes-detail-contenu',
  imports: [ReactiveFormsModule, HlmFieldImports, HlmInputImports],
  templateUrl: './groupe-etapes-detail-contenu.component.html',
})
export class GroupeEtapesDetailContenuComponent implements OnInit {
  readonly detailFormService = inject(GroupeEtapesDetailContenuService);
  readonly #destroyRef = inject(DestroyRef);

  readonly peutModifier = input.required<boolean>();

  readonly form = this.detailFormService.form;

  constructor() {
    effect(() => {
      if (!this.peutModifier()) {
        this.form.disable({ emitEvent: false });
      } else {
        this.form.enable({ emitEvent: false });
      }
    });
  }

  ngOnInit(): void {
    this.form.valueChanges
      .pipe(takeUntilDestroyed(this.#destroyRef), debounceTime(1000), distinctUntilChanged())
      .subscribe(() => this.detailFormService.submit());
  }
}
